//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './SmtpSettingsClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type GetSubtenantSettingsSmtpSettingsQueryParameters = {
  subtenantId: number ;
}

export type PatchSubtenantSettingsSmtpSettingsQueryParameters = {
  subtenantId: number ;
}

export type SendTestMessageSmtpSettingsQueryParameters = {
  subtenantId?: number | undefined ;
  email?: string | undefined ;
}

export function getSubtenantSettingsUrl(subtenantId: number): string {
  let url_ = getBaseUrl() + "/api/mail/settings/smtp/{subtenantId}";
if (subtenantId === undefined || subtenantId === null)
  throw new Error("The parameter 'subtenantId' must be defined.");
url_ = url_.replace("{subtenantId}", encodeURIComponent("" + subtenantId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getSubtenantSettingsDefaultOptions: Omit<UseQueryOptions<Types.SmtpSubtenantSettingsDto, unknown, Types.SmtpSubtenantSettingsDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.SmtpSubtenantSettingsDto, unknown, Types.SmtpSubtenantSettingsDto>, 'queryFn'>> = {
};
export function getGetSubtenantSettingsDefaultOptions() {
  return getSubtenantSettingsDefaultOptions;
};
export function setGetSubtenantSettingsDefaultOptions(options: typeof getSubtenantSettingsDefaultOptions) {
  getSubtenantSettingsDefaultOptions = options;
}

export function getSubtenantSettingsQueryKey(subtenantId: number): QueryKey;
export function getSubtenantSettingsQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { subtenantId,  } = params[0] as GetSubtenantSettingsSmtpSettingsQueryParameters;

    return trimArrayEnd([
        'SmtpSettingsClient',
        'getSubtenantSettings',
        subtenantId as any,
      ]);
  } else {
    return trimArrayEnd([
        'SmtpSettingsClient',
        'getSubtenantSettings',
        ...params
      ]);
  }
}
export function __getSubtenantSettings(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getSubtenantSettings(
      context.queryKey[2] as number,axiosConfig    );
}

export function useGetSubtenantSettingsQuery<TSelectData = Types.SmtpSubtenantSettingsDto, TError = unknown>(dto: GetSubtenantSettingsSmtpSettingsQueryParameters, options?: Omit<UseQueryOptions<Types.SmtpSubtenantSettingsDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets Mail settings for a subtenant.
 */
export function useGetSubtenantSettingsQuery<TSelectData = Types.SmtpSubtenantSettingsDto, TError = unknown>(subtenantId: number, options?: Omit<UseQueryOptions<Types.SmtpSubtenantSettingsDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetSubtenantSettingsQuery<TSelectData = Types.SmtpSubtenantSettingsDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.SmtpSubtenantSettingsDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let subtenantId: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ subtenantId,  } = params[0] as GetSubtenantSettingsSmtpSettingsQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [subtenantId, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.SmtpSubtenantSettingsDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getSubtenantSettings(context, axiosConfig) : __getSubtenantSettings,
    queryKey: getSubtenantSettingsQueryKey(subtenantId),
    ...getSubtenantSettingsDefaultOptions as unknown as Omit<UseQueryOptions<Types.SmtpSubtenantSettingsDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets Mail settings for a subtenant.
 */
export function setGetSubtenantSettingsData(queryClient: QueryClient, updater: (data: Types.SmtpSubtenantSettingsDto | undefined) => Types.SmtpSubtenantSettingsDto, subtenantId: number) {
  queryClient.setQueryData(getSubtenantSettingsQueryKey(subtenantId),
    updater
  );
}

/**
 * Gets Mail settings for a subtenant.
 */
export function setGetSubtenantSettingsDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.SmtpSubtenantSettingsDto | undefined) => Types.SmtpSubtenantSettingsDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function patchSubtenantSettingsUrl(subtenantId: number): string {
  let url_ = getBaseUrl() + "/api/mail/settings/smtp/{subtenantId}";
if (subtenantId === undefined || subtenantId === null)
  throw new Error("The parameter 'subtenantId' must be defined.");
url_ = url_.replace("{subtenantId}", encodeURIComponent("" + subtenantId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function patchSubtenantSettingsMutationKey(subtenantId: number): MutationKey {
  return trimArrayEnd([
      'SmtpSettingsClient',
      'patchSubtenantSettings',
      subtenantId as any,
    ]);
}

/**
 * Patches Mail settings for a subtenant.
 */
export function usePatchSubtenantSettingsMutation<TContext>(subtenantId: number, options?: Omit<UseMutationOptions<void, unknown, Types.SmtpSubtenantSettingsPatchDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.SmtpSubtenantSettingsPatchDto, TContext> {
  const key = patchSubtenantSettingsMutationKey(subtenantId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.SmtpSubtenantSettingsPatchDto) => Client.patchSubtenantSettings(subtenantId, dto),
    mutationKey: key,
  });
}
  
type PatchSubtenantSettings__MutationParameters = PatchSubtenantSettingsSmtpSettingsQueryParameters & {
  dto: Types.SmtpSubtenantSettingsPatchDto;
}

/**
 * Patches Mail settings for a subtenant.
 */
export function usePatchSubtenantSettingsMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, PatchSubtenantSettings__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: PatchSubtenantSettingsSmtpSettingsQueryParameters}): UseMutationResult<void, unknown, PatchSubtenantSettings__MutationParameters, TContext> {
  const key = patchSubtenantSettingsMutationKey(options?.parameters?.subtenantId!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: PatchSubtenantSettings__MutationParameters) => Client.patchSubtenantSettings(data.subtenantId ?? options?.parameters?.subtenantId!, data.dto),
  mutationKey: key,
});
}
  
export function sendTestMessageUrl(subtenantId?: number | undefined, email?: string | undefined): string {
  let url_ = getBaseUrl() + "/api/mail/settings/smtp/send-test-message?";
if (subtenantId === null)
    throw new Error("The parameter 'subtenantId' cannot be null.");
else if (subtenantId !== undefined)
    url_ += "subtenantId=" + encodeURIComponent("" + subtenantId) + "&";
if (email === null)
    throw new Error("The parameter 'email' cannot be null.");
else if (email !== undefined)
    url_ += "email=" + encodeURIComponent("" + email) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function sendTestMessageMutationKey(subtenantId?: number | undefined, email?: string | undefined): MutationKey {
  return trimArrayEnd([
      'SmtpSettingsClient',
      'sendTestMessage',
      subtenantId as any,
      email as any,
    ]);
}

/**
 * Send the test email to check SMTP settings.
 * @param subtenantId (optional) 
 * @param email (optional) Recipient email
 */
export function useSendTestMessageMutation<TContext>(subtenantId?: number | undefined, email?: string | undefined, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = sendTestMessageMutationKey(subtenantId, email);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.sendTestMessage(subtenantId, email),
    mutationKey: key,
  });
}
  
type SendTestMessage__MutationParameters = SendTestMessageSmtpSettingsQueryParameters

/**
 * Send the test email to check SMTP settings.
 * @param subtenantId (optional) 
 * @param email (optional) Recipient email
 */
export function useSendTestMessageMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, SendTestMessage__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: SendTestMessageSmtpSettingsQueryParameters}): UseMutationResult<void, unknown, SendTestMessage__MutationParameters, TContext> {
  const key = sendTestMessageMutationKey(options?.parameters?.subtenantId!, options?.parameters?.email!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: SendTestMessage__MutationParameters) => Client.sendTestMessage(data.subtenantId ?? options?.parameters?.subtenantId!, data.email ?? options?.parameters?.email!),
  mutationKey: key,
});
}